// Hilfsfunktionen für Datumskonvertierung zwischen verschiedenen Formaten

// TTMMYYYY -> TT.MM.YYYY für Anzeige
export function formatDateForDisplay(ttmmyyyy) {
  if (!ttmmyyyy || ttmmyyyy.length !== 8) return ttmmyyyy;
  
  const day = ttmmyyyy.slice(0, 2);
  const month = ttmmyyyy.slice(2, 4);
  const year = ttmmyyyy.slice(4, 8);
  
  return `${day}.${month}.${year}`;
}

// TT.MM.YYYY -> TTMMYYYY für Backend
export function formatDateForBackend(displayDate) {
  if (!displayDate) return '';
  
  if (displayDate.includes('.')) {
    const parts = displayDate.split('.');
    if (parts.length === 3) {
      const day = parts[0].padStart(2, '0');
      const month = parts[1].padStart(2, '0');
      const year = parts[2];
      return `${day}${month}${year}`;
    }
  } else if (displayDate.length === 8 && /^\d{8}$/.test(displayDate)) {
    // Bereits im TTMMYYYY Format
    return displayDate;
  }
  
  return displayDate;
}

// YYYY-MM-DD (ISO) -> TTMMYYYY
export function isoToTTMMYYYY(isoDate) {
  if (!isoDate) return '';
  
  const match = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    const [, year, month, day] = match;
    return `${day}${month}${year}`;
  }
  
  return isoDate;
}

// TTMMYYYY -> YYYY-MM-DD (ISO)
export function ttmmyyyyToISO(ttmmyyyy) {
  if (!ttmmyyyy || ttmmyyyy.length !== 8) return ttmmyyyy;
  
  const day = ttmmyyyy.slice(0, 2);
  const month = ttmmyyyy.slice(2, 4);
  const year = ttmmyyyy.slice(4, 8);
  
  return `${year}-${month}-${day}`;
}

// Validate TTMMYYYY format
export function isValidTTMMYYYY(dateString) {
  if (!dateString || dateString.length !== 8 || !/^\d{8}$/.test(dateString)) {
    return false;
  }
  
  const day = parseInt(dateString.slice(0, 2));
  const month = parseInt(dateString.slice(2, 4));
  const year = parseInt(dateString.slice(4, 8));
  
  // Basic validation
  if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900 || year > 2100) {
    return false;
  }
  
  return true;
}

// Current date in TTMMYYYY format
export function getCurrentTTMMYYYY() {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = String(now.getFullYear());
  
  return `${day}${month}${year}`;
}
